import { Component, Input } from '@angular/core';

@Component({
  selector: 'ap-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.css']
})
export class JumbotronComponent {

  @Input() icon: string;

  constructor() { }

}
